import ApiBase from '../ApiBase';

class BookingItem extends ApiBase {
    route = '/exhibitors/booking-items';
}

export default new BookingItem();
